import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { NotificationType } from '@app/shared/interfaces';
import { AppsService } from '@app/shared/services/apps/apps.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { DialogCreateEmailRouteComponent } from '../../components/dialog-create-email-route/dialog-create-email-route.component';

@Component({
  standalone: false,
  selector: 'sbnb-email-routing',
  templateUrl: './email-routing.component.html',
  styleUrls: ['./email-routing.component.scss'],
})
export class EmailRoutingComponent implements OnInit {
  emails: any[];
  generatingEmail: boolean;

  constructor(
    private appsService: AppsService,
    private toast: ToastNotificationsService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.appsService.getEmailRoutes().subscribe((res) => {
      this.emails = res;

      this.emails.forEach((email, index, array) => {
        array[index].forward_to = email.forward_to.join(',');
      });
    });
  }

  displayEmailAddress(email: any) {
    return email.address.includes('@') ? email.address : email.address + '@' + email.domain;
  }

  updateEmail(email) {
    email.updating = true;

    const payload = {
      forward_to: email.forward_to,
    };

    this.appsService.updateEmailRoute(email.id, payload).subscribe((res) => {
      if (res.errors) {
        this.toast.open(Object.values(res.errors)[0] as string, 'Dismiss', NotificationType.Error);
        email.updating = false;
        return;
      }

      email.updating = false;
      email.updateResult = res;
      setTimeout(() => {
        email.updateResult = null;
      }, 3000);
    });
  }

  createEmail(email) {
    email.saving = true;

    const payload = {
      address: email.address,
      domain: email.domain,
      forward_to: email.forward_to,
    };

    this.appsService.createEmailRoute(payload).subscribe((res) => {
      if (res.errors) {
        this.toast.open(Object.values(res.errors)[0] as string, 'Dismiss', NotificationType.Error);
        email.saving = false;
        return;
      }

      email.saving = false;
      email.id = res.id;
    });
  }

  learnMore() {
    window.open('https://my.hospitable.com/support-documentation/article/4596824-what-is-email-routing', '_blank');
  }

  deleteEmail(email) {
    email.deleting = true;
    this.appsService.deleteEmailRoute(email.id).subscribe((res) => {
      if (res.success) {
        const index = this.emails.findIndex((x) => x.id === email.id);

        if (index > -1) {
          this.emails.splice(index, 1);
        }
      }
    });
  }

  generateEmail() {
    const dialogRef = this.dialog.open(DialogCreateEmailRouteComponent, {
      width: '720px',
      maxHeight: '90vh',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.emails.push({
          address: `${result}`,
          domain: `host.hospitable.com`,
          forward_to: ``,
        });
      }
    });
  }
}
